
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIngresosPorRangoConFiltros"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fechaInicial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fechaFinal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filtroOrganismo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagina"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cantidadPorPagina"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIngresosPorRangoConFiltros"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fechaInicial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fechaInicial"}}},{"kind":"Argument","name":{"kind":"Name","value":"fechaFinal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fechaFinal"}}},{"kind":"Argument","name":{"kind":"Name","value":"filtroOrganismo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filtroOrganismo"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagina"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagina"}}},{"kind":"Argument","name":{"kind":"Name","value":"cantidadPorPagina"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cantidadPorPagina"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detalle"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipo_sello"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeracionInicial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeracionFinal"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fechaEnvio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaArrivo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remitente"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"receptor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":667}};
    doc.loc.source = {"body":"query getIngresosPorRangoConFiltros(\n  $fechaInicial: Date\n  $fechaFinal: Date\n  $filtroOrganismo: String\n  $pagina: Int\n  $cantidadPorPagina: Int\n) {\n  getIngresosPorRangoConFiltros(\n    fechaInicial: $fechaInicial\n    fechaFinal: $fechaFinal\n    filtroOrganismo: $filtroOrganismo\n    pagina: $pagina\n    cantidadPorPagina: $cantidadPorPagina\n  ) {\n    _id\n    numero\n    detalle {\n      tipo_sello {\n        _id\n        nombre\n        valor\n      }\n      cantidad\n      numeracionInicial\n      numeracionFinal\n    }\n    fechaEnvio\n    fechaArrivo\n    importe\n    estado\n    remitente {\n      _id\n      nombre\n    }\n    receptor {\n      _id\n      nombre\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getIngresosPorRangoConFiltros"] = oneQuery(doc, "getIngresosPorRangoConFiltros");
        
